// extracted by mini-css-extract-plugin
export var description = "styles-module--description--f51cf";
export var item = "styles-module--item--4f2d7";
export var name = "styles-module--name--182ef";
export var section = "styles-module--section--abcca";